/*
 * Copyright © 2023 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */
export const trackerConstants = Object.freeze({
  DEVELOPMENT_ENV: 'development',
  STAGING_ENV: 'staging',
  PRODUCTION_ENV: 'production',
  SCOPE_CATEGORY: 'category',
  SENTRY: 'Sentry',
  EPO: 'Epo',
  FILTERED_CONFIG: '',
});

export const LogLevel = Object.freeze({
  DEBUG: 'DEBUG',
  INFO: 'INFO',
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  FATAL: 'FATAL',
  LOG: 'LOG',
});

// todo move to frontendconfig
const trackerConfig = {
  userStorageKey: 'oidc.user:/auth:frontend',
  integrations: {
    sentry: {
      name: trackerConstants.SENTRY,
      enabled: false,
      release: 'my-project-name@2.3.12',
      environment: trackerConstants.DEVELOPMENT_ENV,
      dsn: 'https://b3e0a51a8e6440319b41bb560919a568@o4504360342388736.ingest.sentry.io/4504360343896064',
      integrations(integrations) {
        return integrations.filter(integration => integration.name !== trackerConstants.FILTERED_CONFIG);
      },
      maxBreadcrumbs: 50,
      debug: true,
      tracesSampleRate: 1.0,
    },
  },
};

export default trackerConfig;
